<template>
  <span class="inline-block">
    <q-icon v-if="total === -1" name="fa fa-spinner fa-spin" />
    <span v-else>{{ total }}</span>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import postsRepository from '@/social/post/post-repository';
import { PostFilters } from '@/type';

interface Data {
  total: number,
  timerId: number|null
}

export default defineComponent({
  props: {
    filters: {
      type: Object as () => PostFilters,
      required: true,
    },
  },
  data(): Data {
    return {
      total: -1,
      timerId: null,
    };
  },
  watch: {
    filters: {
      handler(newFilters: PostFilters, oldFilters: PostFilters): void {
        if (_.isEqual(newFilters, oldFilters)) return;
        this.load();
      },
      immediate: true,
      deep: true,
    },
    total(): void {
      this.$el.classList.add('pulse-grow');
      setTimeout(() => {
        this.$el.classList.remove('pulse-grow');
      }, 1000);
    },
  },
  methods: {
    clearTimer(): void {
      if (this.timerId) {
        window.clearTimeout(this.timerId);
      }
      this.timerId = null;
    },
    load(): void {
      this.clearTimer();
      this.total = -1;
      const count = async () => {
        this.total = await postsRepository.count(this.filters);
        this.timerId = window.setTimeout(count, 10000);
      };
      count();
    },
  },
  beforeUnmount(): void {
    this.clearTimer();
  },
});
</script>
